import styled from 'styled-components'

const BaseSelectBoxWrapper = styled.div<{ $capColor: string | null }>`
  border: 1px solid #999;
  color: #333;
  padding: 0;
  position: relative;
  vertical-align: bottom;

  &::before {
    border-color: ${(props) => props.$capColor ?? 'transparent'} transparent transparent;
    border-style: solid;
    border-width: 6px 5px 0;
    content: '';
    height: 0;
    margin-top: -3px;
    pointer-events: none;
    position: absolute;
    right: 0.75em;
    top: 50%;
    width: 0;
  }
`

export default BaseSelectBoxWrapper
